const royaltiesPieChartCol = {
  [`Gold Tier`]: "#FFA06A",
  [`Silver Tier`]: "#54B5BB",
  [`Artist Share`]: "#BF449C",
  [`Platinum Tier`]: "#8372EA",
  
  
};

export { royaltiesPieChartCol };
